import AboutPage from "./pages/AboutPage";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";
import { PromotionBanner } from "./components/layout/PromotionBanner";
import { AnnouncementBanner } from "./components/layout/AnnouncementBanner";
import styles from "./App.module.css";
import { HomePage } from "./pages/HomePage";
import { PaintKitsPage } from "./pages/PaintKitsPage";
import { PaintKitDetailPage } from "./pages/PaintKitDetailPage";
import { ColorPalettesPage } from "./pages/ColorPalettesPage";
import { ColorPaletteDetailPage } from "./pages/ColorPaletteDetailPage";
import { WorkshopsPage } from "./pages/WorkshopsPage";
import { WorkshopDetailPage } from "./pages/WorkshopDetailPage";
import { CustomOrdersPage } from "./pages/CustomOrdersPage";
import { CartPage } from "./pages/CartPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { CartProvider } from "./contexts/CartContext";
import { ScrollToTop } from "./components/common/ScrollToTop";
import { ChatWidget } from "./components/chatbot/ChatWidget";

export default function App() {
  return (
    <Router>
      <ScrollToTop />
      <CartProvider>
        <div className={styles.appContainer}>
          <AnnouncementBanner />
          <PromotionBanner />
          <Navbar />
          <main className={styles.mainContent}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<PaintKitsPage />} />
              <Route path="/products/kits" element={<PaintKitsPage />} />
              <Route path="/products/kits/:id" element={<PaintKitDetailPage />} />
              <Route path="/products/palettes" element={<ColorPalettesPage />} />
              <Route path="/products/palettes/:id" element={<ColorPaletteDetailPage />} />
              <Route path="/products/workshops" element={<WorkshopsPage />} />
              <Route path="/products/workshops/:id" element={<WorkshopDetailPage />} />
              <Route path="/products/custom" element={<CustomOrdersPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </main>
          <Footer />
          <ChatWidget />
        </div>
      </CartProvider>
    </Router>
  );
}
